import { saveAs } from 'file-saver';

const escapeCsvValue = (value: unknown): string => {
  if (value == null) {
    return '';
  }
  if (typeof value === 'boolean') {
    return value ? 'Да' : 'Нет';
  }
  const stringValue = String(value);
  if (stringValue.includes(';') || stringValue.includes('\n') || stringValue.includes('"')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  return stringValue;
};

type SaveAsCsvOptions = {
  filename?: string;
};

// Semicolon delimiter
export const saveAsCSV = (
  data: Record<string, unknown>[],
  header: Record<string, string>,
  options?: SaveAsCsvOptions
) => {
  const keys = Object.keys(header);
  const csvHeader = keys.map((key) => header[key]).join(';');
  const csvRows = data.map((row) => keys.map((key) => escapeCsvValue(row[key])).join(';'));

  const csvData = [csvHeader, ...csvRows].join('\n');
  const blob = new Blob([String.fromCharCode(0xfeff), csvData], { type: 'text/csv;charset=utf-8' });
  saveAs(blob, options?.filename ?? 'data.csv');
};
